export var CalendarProvider;
(function (CalendarProvider) {
    CalendarProvider["GOOGLE_CALENDAR"] = "google_calendar";
    CalendarProvider["YANDEX_CALENDAR"] = "yandex_calendar";
    CalendarProvider["OUTLOOK_CALENDAR"] = "outlook_calendar";
})(CalendarProvider || (CalendarProvider = {}));
//# sourceMappingURL=calendar-provider.enum.js.map